import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import createSlug from "../../utils/CreateSlug";
import Spinner from "../Spinner";

function HoverCadHomeSpecialist() {
  const [doctorsData, setDoctorsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoctorsData();
  }, []);

  const getDoctorsData = async () => {
    try {
      const response = await SendPostRequest("doctors/list");
      setDoctorsData(response?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching doctors data:", error);
      setLoading(false);
    }
  };

  const owlOptions = {
    // loop: true,
    loop: doctorsData.length > 4,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 2500,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      768: { items: 3 },
      1000: { items: 4 },
    },
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {loading ? (
        <div
          style={{ marginBottom: "100px" }}
          className="d-flex align-items-center justify-content-center "
        >
          <Spinner />
        </div>
      ) : doctorsData?.length > 0 ? (
        <div id="team-section" className="team-section py-5">
          <div className="container">
            <div className="row">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                      Meet Our <span className="theme-color">Specialists</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
              <OwlCarousel
                className="owl-carousel team-main-wrapper"
                {...owlOptions}
              >
                {doctorsData?.map((data, index) => (
                  <div className="item animated fadeInDown visible" key={index}>
                    <div className="team-style-1">
                      <div className="team-inner margin-bottom-20">
                        <div className="team-thumb mb-0 relative">
                          <div className="team-overlay"></div>
                          <div
                            className="img-fluid thumb w-100"
                            style={{
                              height: isMobile ? "220px" : "270px",
                              width: "100%",
                              backgroundImage: `url(${data?.profile})`,
                              backgroundSize: isMobile ? "contain" : "cover",
                              backgroundPosition: "top center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div className="team-overlay-details top-left-overlay text-center">
                            {/* <div className="social-icons">
                              <a href="#">
                                <span className="ti-facebook"></span>
                              </a>
                              <a href="#">
                                <span className="ti-twitter"></span>
                              </a>
                              <a href="#">
                                <span className="ti-instagram"></span>
                              </a>
                              <a href="#">
                                <span className="ti-linkedin"></span>
                              </a>
                            </div> */}
                          </div>
                        </div>
                        <div className="team-details text-center pad-20">
                          <div className="team-name">
                            <h3 className="mb-0">
                              <Link
                                to={`/doctor/${data?.uid}/${createSlug(
                                  data?.full_name
                                )}`}
                                className="client-name"
                              >
                                {data?.full_name}
                              </Link>
                            </h3>
                          </div>
                          <div className="team-designation">
                            <p className="mb-0 theme-color">{data?.department}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default HoverCadHomeSpecialist;